import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CrudSectionDefinitionsComponent } from './crud-section-definitions/crud-section-definitions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudAssetRatingComponent } from './crud-asset-rating/crud-asset-rating.component';
import { CrudTsComponent } from './crud-ts/crud-ts.component';
import { CrudMeterTypeComponent } from './crud-meter-type/crud-meter-type.component';
import { CrudDtComponent } from './crud-dt/crud-dt.component';
import { CrudRegionComponent } from './crud-region/crud-region.component';
import { CrudF11Component } from './crud-f11/crud-f11.component';
import { CrudF33Component } from './crud-f33/crud-f33.component';
import { CrudSsComponent } from './crud-is/crud-ss.component';
import { CrudDistrictComponent } from './crud-district/crud-district.component';
import { CrudTariffComponent } from './crud-tariff/crud-tariff.component';

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrl: './crud.component.scss',
  standalone: false,
})
export class CrudComponent implements OnInit {
  @ViewChild(CrudSectionDefinitionsComponent)
  crudSectionDefinitionsComponent!: CrudSectionDefinitionsComponent;
  @ViewChild(CrudTsComponent) crudTsComponent!: CrudTsComponent;
  @ViewChild(CrudMeterTypeComponent) crudMeterTypeComponent!: CrudMeterTypeComponent;
  @ViewChild(CrudDtComponent) crudDtComponent!: CrudDtComponent;
  @ViewChild(CrudRegionComponent) crudRegionComponent!: CrudRegionComponent;
  @ViewChild(CrudF11Component) crudF11Component!: CrudF11Component;
  @ViewChild(CrudF33Component) crudF33Component!: CrudF33Component;
  @ViewChild(CrudTariffComponent) crudTariffComponent!: CrudTariffComponent;
  @ViewChild(CrudSsComponent) crudSsComponent!: CrudSsComponent;
  @ViewChild(CrudDistrictComponent) crudDistrictCmponent!: CrudDistrictComponent;
  @ViewChild(CrudAssetRatingComponent)
  crudAssetRatingComponent!: CrudAssetRatingComponent;

  selectedSidebarItem: string = '';

  downloadClicked: boolean = false;
  saveClicked: boolean = false;
  reloadTable: boolean = false;
  refreshKey = 0;

  searchText: string = '';
  implemented = [
    'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE',
    'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION',
    'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER',
    'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION',
    'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER',
    'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER',
    'COMMON.UT.SINGLE',
    'COMMON.BU.SINGLE',
    'CRUD_SETTINGS.CATEGORIES.TARIFF',
    'CRUD_SETTINGS.CATEGORIES.METER_TYPE',
    'CRUD_SETTINGS.CATEGORIES.ASSET_RATING',
    'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS'
  ];

  constructor(
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getSelectedItemByUrlId();
  }

  currentFilterTemplate: TemplateRef<any> | null = null;

  onFilterTemplateReady(template: TemplateRef<any>) {
    this.currentFilterTemplate = template;
  }

  onSidebarItemSelected(item: string) {
    const wasSameItem = this.selectedSidebarItem === item;
    this.selectedSidebarItem = item;
    this.currentFilterTemplate = null;
    this.refreshKey++;
    this.cd.detectChanges();
    if (!this.implemented.includes(item)) {
      this.toastr.info('Not implemented yet!');
    }
  }

  onAddNewClicked() {
    if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS') {
      const id = +this.route.snapshot.paramMap.get('id')!;
      this.router.navigate([`settings/crud/${id}/add-customer`]);
    } else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION') {
      if (this.crudTsComponent) {
        this.crudTsComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER'){
      if(this.crudF33Component){
        this.crudF33Component.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION'){
      if(this.crudSsComponent){
        this.crudSsComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER'){
      if(this.crudF11Component){
        this.crudF11Component.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER'){
      if(this.crudDtComponent){
        this.crudDtComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE'){
      if(this.crudSectionDefinitionsComponent){
        this.crudSectionDefinitionsComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'COMMON.UT.SINGLE'){
      if(this.crudDistrictCmponent){
        this.crudDistrictCmponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'COMMON.BU.SINGLE'){
      if(this.crudRegionComponent){
        this.crudRegionComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.TARIFF'){
      if(this.crudTariffComponent){
        this.crudTariffComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.METER_TYPE'){
      if(this.crudMeterTypeComponent){
        this.crudMeterTypeComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.ASSET_RATING'){
      if(this.crudAssetRatingComponent){
        this.crudAssetRatingComponent.openAddModal();
      }
    }
    else if (this.selectedSidebarItem) {
      this.toastr.info('Add functionality not implemented for this category!');
    }
  }

  getSelectedItemByUrlId() {
    const id = +this.route.snapshot.paramMap.get('id')!;
    switch (id) {
      case 0: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION';
        break;
      }
      case 1: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER';
        break;
      }
      case 2: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION';
        break;
      }
      case 3: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER';
        break;
      }
      case 4: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER';
        break;
      }
      case 5: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE';
        break;
      }
      case 6: {
        this.selectedSidebarItem = 'COMMON.UT.SINGLE';
        break;
      }
      case 7: {
        this.selectedSidebarItem = 'COMMON.BU.SINGLE';
        break;
      }
      case 8: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.TARIFF';
        break;
      }
      case 9: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.METER_TYPE';
        break;
      }
      case 10: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.ASSET_RATING';
        break;
      }
      case 11: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.ASSET_STATUS';
        break;
      }
      case 12: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS';
        break;
      }
      case 13: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.DT_METER_TYPE';
        break;
      }
      case 14: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.SLT_STATUS';
        break;
      }
      case 15: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.METER_PRICE';
        break;
      }
      case 16: {
        this.selectedSidebarItem = 'CRUD_SETTINGS.CATEGORIES.BILLING_ACCOUNTS';
        break;
      }
    }
  }
}